const styles = theme => ({
  modalBody: {
    lineHeight: '1.5rem'
  },
  link: {
    color: theme.palette.primary.main,
  },
  emptyListsIcon: {
    ...theme.emptyListsIcon
  },
  noTradesIconWidth: {
    textAlign: 'center' as const
  },
  makeSureDiv: {
    padding: '10px 20px',
    backgroundColor: theme.palette.lightyellow.color,
    color: theme.palette.black.color,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  zeroMarginTop: {
    marginTop: 0
  },
  highlight: {
    fontWeight: 400
  },
  noteList: {
    paddingLeft: 16,
    '& li': {
      paddingTop: 6
    }
  },
  numberedList: {
    paddingLeft: 16,
    '& li': {
      color: theme.palette.secondary.main,
      paddingLeft: 10,
      fontSize: 14
    }
  },
  hidden: {
    display: 'none'
  },
  chooseAccountContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '20px',
  }
})

export {styles}
